import { bootstrappedData } from './bootstrappedData';

export class HTTPClientError<T> extends Error {
	data: T;
	status: number;
	statusText: string;

	constructor(response: Response, data: T) {
		super(
			`Request failed with status ${response.status} ${response.statusText}`,
		);
		this.data = data;
		this.status = response.status;
		this.statusText = response.statusText;
	}
}

async function execute<T>(
	url: string,
	method = 'GET',
	data?: any,
	contentType?: string,
): Promise<T> {
	const headers: HeadersInit = {
		'Accept-Language': bootstrappedData.Language,
	};
	if (data !== undefined) {
		if (typeof data === 'string' && contentType) {
			headers['content-type'] = contentType;
		} else {
			data = JSON.stringify(data);
			headers['content-type'] = 'application/json';
		}
	}

	const res = await window.fetch(url, {
		method,
		body: data,
		headers,
	});

	let returnValue: T;
	if (res.headers.get('content-type')?.startsWith('application/json')) {
		returnValue = await res.json();
	} else {
		returnValue = (await res.text()) as any;
	}

	if (res.status >= 400) {
		throw new HTTPClientError(res, returnValue);
	}

	return returnValue;
}

export const httpClient = {
	execute,
	get<T>(url: string): Promise<T> {
		return execute(url, 'GET');
	},
	post<T>(url: string, data?: unknown, contentType?: string): Promise<T> {
		return execute(url, 'POST', data, contentType);
	},
	put<T>(url: string, data?: unknown, contentType?: string): Promise<T> {
		return execute(url, 'PUT', data, contentType);
	},
	delete<T>(url: string): Promise<T> {
		return execute(url, 'DELETE');
	},
};
